var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 22 18"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20.6,
  height: 17,
  x: 0.5,
  y: 0.5,
  stroke: "currentColor",
  rx: 2.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 4.256h21.6v5.4H0zm2.517 9.657h2.7v.9h-2.7zm4.546 0h4.5v.9h-4.5z"
})));
export { SvgCardIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIxOCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDIyIDE4Ij4KICA8cmVjdCB3aWR0aD0iMjAuNiIgaGVpZ2h0PSIxNyIgeD0iLjUiIHk9Ii41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgcng9IjIuNSIvPgogIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTAgNC4yNTZoMjEuNnY1LjRIMHptMi41MTcgOS42NTdoMi43di45aC0yLjd6bTQuNTQ2IDBoNC41di45aC00LjV6Ii8+Cjwvc3ZnPgo=";